<template>
  <el-row :gutter="15">
    <el-col :span="12" :xs="24">
      <el-card>
        <div class="stat-card">
          <div class="card-description">
            <p class="title">
              <i class="el-icon-sell color-success"></i>
              <span>商家总营收</span>
            </p>
            <span class="count">￥</span>
            <count-to class="count" :start-val='0' :decimals="2" :end-val='+convertYuan(revenue.total)' :duration='3000'></count-to>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :span="12" :xs="24">
      <div class="stat-card right-content">
        <el-card>
          <div class="card-description">
            <p class="title">
              <i class="el-icon-sell color-danger"></i>
              <span>本月营收</span>
            </p>
            <div>
              <span class="count">￥</span>
              <count-to class="count" :start-val='0' :decimals="2" :end-val='+convertYuan(revenue.month)' :duration='3000'></count-to>
            </div>
          </div>
        </el-card>
        <el-card>
          <div class="card-description">
            <p class="title">
              <i class="el-icon-sell color-warning"></i>
              <span>昨日营收</span>
            </p>
            <div>
              <span class="count">￥</span>
              <count-to class="count" :start-val='0' :decimals="2" :end-val='+convertYuan(revenue.yestoday)' :duration='3000'></count-to>
            </div>
          </div>
        </el-card>
        <el-card>
          <div class="card-description">
            <p class="title">
              <i class="el-icon-sell color-primary"></i>
              <span>今日营收</span>
            </p>
            <div>
              <span class="count">￥</span>
              <count-to class="count" :start-val='0' :decimals="2" :end-val='+convertYuan(revenue.today)' :duration='3000'></count-to>
            </div>
          </div>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import CountTo from "vue-count-to";
  export default {
    name: "BillRevenue",
    components: {CountTo},
    data() {
      return {
        revenue: {
          total: 0,
          today: 0,
          yestoday: 0,
          month: 0,
        },
        growth: 0,
      }
    },
    created() {
      this.getData();
    },
    methods: {
      async getData() {
        let res = await this.$Http.getBillRevenue();
        if (res?.data) {
          this.revenue = res.data || {};
          this.growth = this.getGrowthRate({now: this.revenue.today, before: this.revenue.yestoday})
        }
      },
      //增长率
      getGrowthRate({now, before} = {}) {
        return (now === 0 ? -100 : (now - before) / now * 100).toFixed(0);
      },
    }
  }
</script>

<style scoped lang="scss">
  .stat-card {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.right-content {
      flex-direction: column;
      height: calc(400px + 55px);
      .el-card {
        width: 100%;
        flex: 1;
        /deep/ {
          .el-card__body {
            box-sizing: border-box;
            height: 100%;
            .card-description {
              height: 100%;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              .title {
                flex-direction: row;
                i {
                  font-size: 20px;
                  margin: 0 5px;
                }
              }
            }
          }
        }
      }
    }
    .card-description {
      text-align: center;
      font-family: "Poppins",Poppins,Arial,sans-serif;
      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        i {
          font-size: 80px;
          margin-bottom: 20px;
        }
        span {
          color: #aab2bd;
        }
      }
      .count {
        font-size: 30px;
        font-weight: 500;
        color: #212121;
      }
      .content {
        margin-top: 5px;
        font-size: 13px;
        color: #aab2bd;
      }
    }
  }
</style>
